import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Contact } from './model/contact';
import { catchError, delay, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constants } from './constants';
import { ErrorHandlingService } from '../../core/service/error-handling.service';
import { ToastService } from '../../core/service/toast.service';
import { ToastMessage } from '../../core/model/toast-message';

@Injectable({
  providedIn: 'root',
})
export class ContactIntakeService {
  apiUrl: string;

  constructor(
    private errorHandlingService: ErrorHandlingService,
    private httpClient: HttpClient,
    private toastService: ToastService,
  ) {
    this.apiUrl = environment.apiUrl;
  }

  saveContact(contact: Contact): Observable<string | null> {
    // console.log('# saving contact: ', JSON.stringify(contact));
    const saveContactUrl = this.apiUrl + Constants.contactIntake();
    return this.httpClient.post<string>(saveContactUrl, contact).pipe(
      delay(1000),
      tap(() =>
        this.toastService.success({
          message: `Danke für deine Interesse ${contact.firstname}, wir melden uns bei dir baldmöglichst`,
        } as ToastMessage),
      ),
      catchError((error) => this.errorHandlingService.handleError(error)),
    );
  }
}
